import Dropdown from 'react-bootstrap/Dropdown'
import 'bootstrap/dist/css/bootstrap.css'
import {useState} from 'react'
import Players from './Players'

const FilterView = ({filter, setOpened, setNewPlayer})=>{

    //change state of header
    const[title, setTitle] = useState(filter)
    const dropItem = ['All', 'Western Conference', 'Eastern Conference', 'Point Guard', 'Shooting Guard', 'Small Forward', 'Power Forward', 'Center']

    return(

        <div id="display-view-container">

            <div id="filter-container">
                <h2 id="header-filter">{title}</h2>
                <Dropdown >
                    <Dropdown.Toggle  variant='success' id="dropdown">
                        {title}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {
                            dropItem.map(item => 
                                <Dropdown.Item onClick={()=>setTitle(item)}>{item}</Dropdown.Item>    
                            )
                        }
                        
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <div id='player-container'>
                <table id="playerTable">
                    <thead>
                        <tr>
                            <th>NAME</th>
                            <th>TEAM</th>
                            <th>POSITION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <Players title={title} setOpened={setOpened} setNewPlayer={setNewPlayer}/>
                    </tbody>
                </table>
            </div>
            
            
        </div>
        
        
    )
}

export default FilterView
